import styled, { css } from 'styled-components';
import CurrencyInput from 'react-currency-input-field';

interface IErrors {
    error?: string;
}

export const Container = styled(CurrencyInput)<IErrors>`
    && {
        ${({ theme, error }) => css`
            font-size: ${theme.fontSizes.default};
            height: 3.5rem;
            border-radius: 8px;
            color: ${theme.colors.font};
            border: 1px solid #d9d9d9;
            padding: 0 1rem;
            transition: border-color 0.2s ease-in-out;
            width: 100%;

            &:focus {
                outline: none;
                box-shadow: 0 0 0.2em ${theme.colors.accentColor};
                transition: box-shadow 0.2s ease-in-out;
            }

            &:hover,
            &:focus {
                ${!error &&
                css`
                    border-color: ${theme.colors.accentColor};
                `};
            }

            ${error &&
            css`
                border-color: ${theme.colors.fail};
            `};
        `};
    }
`;

export const Title = styled.p`
    ${({ theme }) => css`
        color: ${theme.colors.font};
        font-size: ${theme.fontSizes.little};
        margin-bottom: 0.5rem;
    `}
`;
